import { render } from "./MailboxIntegration.vue?vue&type=template&id=2aecd102"
import script from "./MailboxIntegration.vue?vue&type=script&lang=js"
export * from "./MailboxIntegration.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__